import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import PromoForm from './PromoForm'
import { storePromo } from '../services'
import { handleError } from '../../../helpers'

export default function NewPromoModal({ visible, onClose, reload }) {
	const { register, handleSubmit, formState: { errors }, reset } = useForm()

	const onSubmit = values => {
		storePromo(values)
			.then(() => {
				message.success('Dinámica creada exitosamente.')
				reset()
				reload()
				onClose()
			})
			.catch(error => handleError(error))
	}	

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Crear Dinámica</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<PromoForm register={register} errors={errors} />
						<Button type="submit" color="primary">Crear Dinámica</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}